<template>
  <div>
    <medical-plan
      v-if="student"
      :consent-services="consentServices"
      is-read-only
      :services="services"
      :sign-services="signServices"
      :signature-hub-services="signatureHubServices"
      :student="student"
      @back="back"
    />
  </div>
</template>

<script>
import generalService from '@/modules/app/api';
import { getById as getStudent } from '@/modules/shared/student.api';
import documentsService from '@/modules/shared/documents.api.js';

import {
  getPlanTypes,
  get,
  save,
  getHistory,
  getConsent,
  searchConsent,
  saveConsent,
  markSigned,
  saveMechanism,
  saveSignedDocument,
} from '@/modules/student/medical-plan/api';

import {
  getSignatureHubInfo,
  removeSignatureHub,
} from '@/modules/signatureHub/api';

import MedicalPlan from 'medical-plan';

export default {
  name: 'MedicalPlanMain',
  components: { MedicalPlan },
  props: { sie: { type: [String, Number], default: null } },
  data() {
    return {
      student: null,
    };
  },
  computed: {
    services() {
      return Object.freeze({
        getPlanTypes,
        get,
        save,
        getHistory,
        downloadFile: generalService.getDocument,
      });
    },
    consentServices() {
      return Object.freeze({
        get: getConsent,
        search: searchConsent,
        save: saveConsent,
        sign: markSigned,
        saveMechanism,
        saveSignedDocument,
      });
    },
    signServices() {
      return Object.freeze({
        download: documentsService.downloadFromServer,
        downloadTemplate: generalService.getMedicalPlanConsent,
      });
    },
    signatureHubServices() {
      return Object.freeze({
        get: getSignatureHubInfo,
        remove: removeSignatureHub,
      });
    },
  },
  async mounted() {
    await this.getStudent();
  },
  methods: {
    back() {
      this.$router.back();
    },
    async getStudent() {
      if (!this.sie) return;
      const { data } = await getStudent(this.sie);
      if (!data) return;
      this.student = Object.freeze({
        id: Number(this.sie),
        name: data.fullName,
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
